/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Dokument } from '../../models/dokument';

export interface ApiWebInstytucjeNipHistoriaZioIdGet$Xml$Params {
  nip: string;
  zioId: number;
}

export function apiWebInstytucjeNipHistoriaZioIdGet$Xml(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipHistoriaZioIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Dokument>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipHistoriaZioIdGet$Xml.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.path('zioId', params.zioId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Dokument>;
    })
  );
}

apiWebInstytucjeNipHistoriaZioIdGet$Xml.PATH = '/api/web/instytucje/{nip}/historia/{zioId}';
